import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import useTeamFindById from '@opsbase/react-gql-hooks/team/useTeamFindById';
import useTeamUpdate from '@opsbase/react-gql-hooks/team/useTeamUpdate';
import Dialog from '@opsbase/web-dialogs/Dialog';
import useParams from '@opsbase/web-nav/useParams';
import React, { useCallback } from 'react';
export function TeamEditDialog() {
    const { id } = useParams();
    const { loading, data } = useTeamFindById({ variables: { id } });
    const updateTeam = useTeamUpdate();
    const handleChangeTitle = useCallback(title => {
        if (!title)
            return;
        updateTeam({
            id: data.id,
            patch: { title },
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updateTeam: {
                    __typename: 'Team',
                    ...data,
                    title,
                },
            },
        }).catch(doNothing);
    }, [data, updateTeam]);
    return (React.createElement(Dialog, { editableTitle: true, title: data ? data.title : i18n.t('loading'), onChangeTitle: handleChangeTitle, loading: loading || !data }));
}
export default TeamEditDialog;
